import React, { useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import {
  getStoreId,
  getCatalogId,
  getBaseURL,
  getLangId,
} from "../../Shared/AppContext/selectors/index";
import { UserContext } from "../../UserContext";
import { jsonApiHeader, checkHttpStatus } from "../../Shared/utility";
import { useState } from "react";
import queryString from "query-string";
import solventumLogo from "../../assets/images/solventum.svg";

const ReviewPurchaseDetails = ({ currentFileRequired, translationKey }) => {
  const {
    orderId,
    cartItemsData: cartItems,
    cartItemsQty,
  } = useContext(UserContext);

  // Get currency from order API (dynamic)
  const checkoutCurrency =
    cartItems?.grandTotalCurrency ||
    cartItems?.totalProductPriceCurrency ||
    cartItems?.currency ||
    "USD";
  
  // Create currency formatter
  const currencyFormatter = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: checkoutCurrency,
  });

  const getDisplayUnitPrice = (lineItemData) => {
    const parsedListPrice = Number.parseFloat(lineItemData?.listPrice);
    if (Number.isFinite(parsedListPrice) && parsedListPrice > 0) {
      return parsedListPrice;
    }
    return getDisplayNetUnitPrice(lineItemData);
  };

  const getDisplayNetUnitPrice = (lineItemData) => {
    const parsedUnitPrice = Number.parseFloat(lineItemData?.unitPrice);
    if (Number.isFinite(parsedUnitPrice)) {
      return parsedUnitPrice;
    }
    const parsedListPrice = Number.parseFloat(lineItemData?.listPrice);
    return Number.isFinite(parsedListPrice) ? parsedListPrice : 0;
  };

  const getDisplayTotalPrice = (lineItemData) => {
    const parsedQty = Number.parseFloat(lineItemData?.quantity);
    const quantity = Number.isFinite(parsedQty) ? parsedQty : 0;
    return getDisplayNetUnitPrice(lineItemData) * quantity;
  };
  
  const [customWeldedBandsData, setCustomWeldedBandsData] = useState([]);
  const [cartItemsData, setCartItemsData] = useState([]);
  const [totalCost, setTotalCost] = useState(null);
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  useEffect(() => {
    if (cartItems) {
      setTotalCost(parseFloat(cartItems?.totalProductPrice).toFixed(2));
    }
  }, [cartItems]);

  const baseURL = useSelector(getBaseURL);
  const storeId = useSelector(getStoreId);
  const catalogId = useSelector(getCatalogId);
  const langId = useSelector(getLangId);
  useEffect(() => {
    async function getReviewItemsDetails() {
      //https://localhost/wcs/resources/store/10051/3mcart/lineitems/order/50334736812
      const response = await fetch(
        `/wcs/resources/store/${storeId}/3mcart/lineitems/order/${orderId}`,
        {
          method: "GET",
          headers: jsonApiHeader(),
        }
      );
      const data = await checkHttpStatus(response);
      if (
        data &&
        data.groupedLineItemsList &&
        data.groupedLineItemsList.length
      ) {
        const customBands = data.groupedLineItemsList.find(
          (customBandData) =>
            customBandData.categoryName ===
            "Custom Welded Bands (Prescription Bands)"
        );
        const cartData = data.groupedLineItemsList.filter(
          (data) =>
            data.categoryName !== "Custom Welded Bands (Prescription Bands)"
        );
        const query = queryString.stringify({
          catalogId,
          profileName: "Solventum_findProductByIds_Summary",
        });

        // let newCartDataWithPrescriptions = cartData.map((data) => {
        //   return (
        //     data.lineItems.length &&
        //     data.lineItems.map(async (lineItem, lineItemIndex) => {
        //       let prescriptionsAvailable = "";
        //       await fetch(
        //         `/search/resources/store/${storeId}/productview/byId/${lineItem.productId}?${query}`,
        //         {
        //           method: "GET",
        //           headers: jsonApiHeader(),
        //         }
        //       )
        //         .then(checkHttpStatus)
        //         .then(function (response) {
        //           console.log("re", response);

        //           if (
        //             response.catalogEntryView &&
        //             response.catalogEntryView.length &&
        //             response.catalogEntryView[0].attributes &&
        //             response.catalogEntryView[0].attributes.length
        //           ) {
        //             let entryWithPrescription =
        //               response.catalogEntryView[0].attributes.find(
        //                 (data) => data.identifier === "Prescription"
        //               );
        //             if (
        //               entryWithPrescription &&
        //               entryWithPrescription.values &&
        //               entryWithPrescription.values.length
        //             ) {
        //               entryWithPrescription.values.forEach((attributeData) => {
        //                 prescriptionsAvailable =
        //                   prescriptionsAvailable !== ""
        //                     ? prescriptionsAvailable +
        //                       "," +
        //                       attributeData.identifier
        //                     : prescriptionsAvailable + attributeData.identifier;
        //               });
        //             }
        //           }
        //         });

        //       return { ...lineItem, prescriptionsAvailable };

        //       console.log("data", data, lineItem);
        //       // return [...data]
        //     })
        //   );
        // });
        // console.log("new", newCartDataWithPrescriptions);

        var newD = [...cartData];
        newD.push({
          lineItems: [
            {
              unitPrice: 65.57,
              bandOrderDetail: null,
              bandType: null,
              quantity: 18,
              orderItemId: 2578204,
              totalProduct: 1180.26,
              bandCcomments: null,
              isBandOrder: null,
              productName:
                "Solventum™ Unitek™ Beta III Titanium Archwire                                                                                      ",
              unit: "PK",
              productShortDescription:
                "Solventum™ Unitek™ Beta III Titanium Archwire, .017x.025, OrthoForm™ III Ovoid, Lower, 4301-311, Unit of Use, 10/Pk",
              currency: "USD       ",
              partNumber: "4301-311",
            },
            {
              unitPrice: 65.57,
              bandOrderDetail: null,
              bandType: null,
              quantity: 18,
              orderItemId: 2578204,
              totalProduct: 1180.26,
              bandCcomments: null,
              isBandOrder: null,
              productName:
                "Solventum™ Unitek™ Beta III Titanium Archwire                                                                                      ",
              unit: "PK",
              productShortDescription:
                "Solventum™ Unitek™ Beta III Titanium Archwire, .017x.025, OrthoForm™ III Ovoid, Lower, 4301-311, Unit of Use, 10/Pk",
              currency: "USD       ",
              partNumber: "4301-311",
            },
          ],
          categoryName: "Orthodontic Wires",
        });

        setCustomWeldedBandsData(customBands);
        setCartItemsData(cartData);
      }
    }

    if (storeId && orderId) {
      getReviewItemsDetails();
    }
  }, [storeId, orderId]);

  return (
    <div className="review-purchase-details-wrapper">
      <div style={{ display: "flex", alignItems: "center" }}>
        <img src={solventumLogo} height="34px" alt="" />
        <span
          style={{
            color: "#101828",
            marginLeft: "3px",
            fontFamily: "var(--sv-font-sans)",
            fontWeight: 600,
          }}
        >
          Oral Care
        </span>
      </div>
      <h4>{translationKey(currentFileRequired["REVIEW_ITEMS_MESSAGE"])}</h4>
      <table className="review-purchase-details-table">
        <tbody>
          <tr>
            <td className="p-0">
              <table>
                <tbody>
                  {cartItemsData.length
                    ? cartItemsData.map((cartItem, cartItemIndex) => {
                        return (
                          <>
                            <tr>
                              <th
                                style={{ fontSize: "14px", textAlign: "left" }}
                                align="left"
                                className="pl-0"
                              >
                                {cartItem.categoryName || "No Product Category"}{" "}
                                <span style={{ fontSize: "14px" }}>
                                  ({cartItem.itemsQuantity}{" "}
                                  {translationKey(currentFileRequired["ITEMS"])}
                                  )
                                </span>
                              </th>
                              <th align="center">
                                {translationKey(
                                  currentFileRequired["LIST_UNIT_PRICE"]
                                )}
                              </th>
                              <th style={{ textAlign: "left" }}>
                                {translationKey(
                                  currentFileRequired["QUANTITY"]
                                )}
                              </th>
                              <th align="right">
                                {translationKey(
                                  currentFileRequired["NET_UNIT_PRICE"]
                                )}
                              </th>
                              <th align="right" className="pr-0">
                                {translationKey(
                                  currentFileRequired["TOTAL_PRICE"]
                                )}
                              </th>
                            </tr>
                            {cartItem.lineItems.map(
                              (lineItemData, lineItemDataIndex) => {
                                return (
                                  <tr key={lineItemDataIndex.toString()}>
                                    <td align="left" className="pl-0">
                                      <div className="order-id-and-name">
                                        <span
                                          className="order-id"
                                          title={lineItemData.partNumber}
                                          style={{ marginRight: "10px" }}
                                        >
                                          {lineItemData.partNumber}
                                        </span>
                                        <span
                                          style={{ marginLeft: "0px" }}
                                          className="product-name"
                                        >
                                          {lineItemData.productShortDescription}
                                        </span>
                                      </div>
                                    </td>
                                    <td align="center">
                                      <span>
                                        {currencyFormatter.format(
                                          getDisplayUnitPrice(lineItemData)
                                        )}{" "}
                                      </span>
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      <span>
                                        {lineItemData.quantity}{" "}
                                        {lineItemData.unit}
                                      </span>
                                    </td>
                                    <td align="right">
                                      <span>
                                        {currencyFormatter.format(
                                          getDisplayNetUnitPrice(lineItemData)
                                        )}
                                      </span>
                                    </td>
                                    <td align="right" className="pr-0">
                                      <span>
                                        {currencyFormatter.format(
                                          getDisplayTotalPrice(lineItemData)
                                        )}
                                      </span>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </td>
          </tr>
          {customWeldedBandsData ? (
            <tr>
              <td className="p-0">
                <table>
                  <thead>
                    <tr>
                      <th
                        style={{ textAlign: "left" }}
                        align="left"
                        className="pl-0"
                      >
                        {translationKey(
                          currentFileRequired["CUSTOM_BANDS_HEADER"]
                        )}
                      </th>
                      <th align="center">
                        {translationKey(currentFileRequired["LIST_UNIT_PRICE"])}
                      </th>
                      <th style={{ textAlign: "left" }}>
                        {translationKey(currentFileRequired["QUANTITY"])}
                      </th>
                      <th align="right">
                        {translationKey(
                          currentFileRequired["NET_UNIT_PRICE"]
                        )}
                      </th>
                      <th align="right" className="pr-0">
                        {translationKey(currentFileRequired["TOTAL_PRICE"])}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {customWeldedBandsData &&
                    customWeldedBandsData.lineItems &&
                    customWeldedBandsData.lineItems.length
                      ? customWeldedBandsData.lineItems.map(
                          (bandItemData, bandItemIndex) => {
                            return (
                              <React.Fragment key={bandItemIndex.toString()}>
                                <tr>
                                  <td align="left" className="pl-0">
                                    <div className="order-id-and-name">
                                      <span>
                                        {bandItemData.bandType} bands with
                                        attachments
                                      </span>
                                    </div>
                                  </td>
                                  <td align="center">
                                    <span>
                                      {currencyFormatter.format(
                                        getDisplayUnitPrice(bandItemData)
                                      )}
                                    </span>
                                  </td>
                                  <td style={{ textAlign: "left" }}>
                                    <span>
                                      {bandItemData.quantity}{" "}
                                      {bandItemData.unit}
                                    </span>
                                  </td>
                                  <td align="right">
                                    <span>
                                      {currencyFormatter.format(
                                        getDisplayNetUnitPrice(bandItemData)
                                      )}
                                    </span>
                                  </td>
                                  <td align="right" className="pr-0">
                                    <span>
                                      {currencyFormatter.format(
                                        getDisplayTotalPrice(bandItemData)
                                      )}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="5" width="100%" className="p-0">
                                    <div className="custband-and-comment-wrapper">
                                      <table className="checkout-band-prescription-table">
                                        <tbody>
                                          <tr>
                                            <td className="p-0">
                                              <table className="checkout-band-prescription-inner-table">
                                                <thead>
                                                  <tr>
                                                    <th>
                                                      {translationKey(
                                                        currentFileRequired[
                                                          "TYPE"
                                                        ]
                                                      )}
                                                    </th>
                                                    <th>
                                                      {translationKey(
                                                        currentFileRequired[
                                                          "SIZE"
                                                        ]
                                                      )}
                                                    </th>
                                                    <th>
                                                      {translationKey(
                                                        currentFileRequired[
                                                          "QUANTITY"
                                                        ]
                                                      )}
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr>
                                                    <td
                                                      style={{
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      {bandItemData
                                                        .bandOrderDetails[0]
                                                        .arch === "L"
                                                        ? `Lower ${
                                                            bandItemData
                                                              .bandOrderDetails[0]
                                                              .side === "Rt"
                                                              ? "Right"
                                                              : bandItemData
                                                                  .bandOrderDetails[0]
                                                                  .side === "Lt"
                                                              ? "Left"
                                                              : ""
                                                          } `
                                                        : bandItemData
                                                            .bandOrderDetails[0]
                                                            .arch === "U"
                                                        ? `Upper  ${
                                                            bandItemData
                                                              .bandOrderDetails[0]
                                                              .side === "Rt"
                                                              ? "Right"
                                                              : bandItemData
                                                                  .bandOrderDetails[0]
                                                                  .side === "Lt"
                                                              ? "Left"
                                                              : ""
                                                          } `
                                                        : ""}
                                                    </td>
                                                    <td>
                                                      {
                                                        bandItemData
                                                          .bandOrderDetails[0]
                                                          .size
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        bandItemData
                                                          .bandOrderDetails[0]
                                                          .qty
                                                      }
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <div className="comment-block">
                                        <h3>
                                          {translationKey(
                                            currentFileRequired["COMMENTS"]
                                          )}
                                        </h3>
                                        <p>{bandItemData.bandComments}</p>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                            );
                          }
                        )
                      : null}
                  </tbody>
                </table>
              </td>
            </tr>
          ) : null}
          <tr>
            <td className="p-0">
              <table>
                <tbody>
                  <tr className="estimated-sub-total-tr">
                    <td colSpan="5" className="p-0">
                      <div
                        style={{ fontSize: "18px" }}
                        className="estimated-sub-total-wrapper"
                      >
                        {translationKey(
                          currentFileRequired["ESTIMATED_SUBTOTAL"]
                        )}
                        <span
                          style={{ fontSize: "18px" }}
                          className="estimated-total-items"
                        >
                          ({cartItemsQty}{" "}
                          {translationKey(currentFileRequired["ITEMS"])}
                          ):
                        </span>
                        <span
                          style={{ fontSize: "18px" }}
                          className="estimated-sub-total"
                        >
                          {currencyFormatter.format(totalCost)}
                        </span>
                      </div>
                      <div className="both-button">
                        <a
                          href={`${baseURL}StoreAppView?langId=${langId}&storeId=${storeId}&catalogId=${catalogId}&orderId=.&doPrice=N#/my-cart`}
                          className="sec-btn"
                        >
                          {translationKey(
                            currentFileRequired["EDIT_ITEMS_MESSAGE"]
                          )}
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default ReviewPurchaseDetails;
